import React, { ReactElement, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Row,
} from "@jarvis-catalyst/ui-components";
import { useNavigate } from "react-router-dom";
import { useValidateForm } from "../../hooks/useValidateForm";
import { FormAlertGroup } from "../../styled-components/FormGroup";
import { useUser } from "../../hooks/useUser";
import { validateUserOption } from "../../config/data/userOptions";
import { validateIfHasPermissionToAccessView } from "../../utils/filterPermission";
import PersonAccountForm from './validatePersonAccountForm';
import B2bOrEnterpriseAccountForm from './validateB2bOrEnterpriseAccountForm';


const ValidateConsent = (): ReactElement => {
  const navigate = useNavigate();
  const { error, loadingValidate } = useValidateForm();
  const [validateUser] = useState(validateUserOption);
  const { permission } = useUser();
  const [selectedForm, setSelectedForm] = useState<string | null>(null);
  const [b2bState, setB2bState] = useState<boolean>(false);
  const [enterpriseState, setEnterpriseState] = useState<boolean>(false);

  const hasValidPermission = validateUser.some(({ validPermissions }) => {
    return validateIfHasPermissionToAccessView({
      validPermissionsView: validPermissions,
      userPermission: permission,
      action: "read"
    });
  });

  const handleValidationTypeSelected = (formType: 'PersonAccountForm' | 'B2bOrEnterpriseAccount', isB2B: boolean, isEnterprise: boolean) => {
    setSelectedForm(formType);
    setB2bState(isB2B);
    setEnterpriseState(isEnterprise);
  };

  const setInicialStateValues = () => {
    setSelectedForm(null);
    setB2bState(false);
    setEnterpriseState(false);
  };

  if (selectedForm === 'PersonAccountForm')
    return <PersonAccountForm hasValidPermission={hasValidPermission} onBack={() => setInicialStateValues()} />;
  if (selectedForm === 'B2bOrEnterpriseAccount')
    return <B2bOrEnterpriseAccountForm hasValidPermission={hasValidPermission} onBack={() => setInicialStateValues()} isB2B={b2bState} isEnterprise={enterpriseState}/>;

  return (
    <>
      <Row className="d-flex justify-content-center align-items-center">
        <Col md={8} lg={6} xs={12}>
          <Card className="shadow">
            <CardBody>
              <div className="mb-3 mt-md-4">
                <h2 className="fw-bold mb-2 text-uppercase text-center">Validate User & Consents</h2>
                  <br></br>
                  <div className="d-grid">
                    <Button 
                      color="primary"
                      className="mt-2 text-center"
                      disabled={!hasValidPermission}
                      onClick={() => handleValidationTypeSelected("PersonAccountForm", false, false)}
                    >
                      Person account
                    </Button>
                    <Button 
                      color="primary"
                      className="mt-2 text-center"
                      disabled={!hasValidPermission}
                      onClick={() => handleValidationTypeSelected("B2bOrEnterpriseAccount", true, false)}
                    >
                      B2B account
                    </Button>
                    <Button 
                      color="primary"
                      className="mt-2 text-center"
                      disabled={!hasValidPermission}
                      onClick={() => handleValidationTypeSelected("B2bOrEnterpriseAccount", false, true)}
                    >
                      Enterprise account
                    </Button>
                    <br></br>
                    <Button
                      disabled={loadingValidate}
                      color="bordered"
                      type="button"
                      className="mt-2 text-center"
                      onClick={() => navigate("/")}
                    >
                      Back
                    </Button>
                  </div>
              </div>
            </CardBody>
            {error.message && (
              <CardFooter>
                {error.message && (
                  <FormAlertGroup className="text-center">
                    <Alert color="danger">{error.message}</Alert>
                  </FormAlertGroup>
                )}
              </CardFooter>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ValidateConsent;
